<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <div class="col-md-12 ">
        <Header pageTitle="Edit Profile " class="card-container"></Header>
        <div class="d-flex justify-content-end ">
          <base-button type="link" @click="$router.push(`/admin/audit-logs/${$route.params.id}`)">
            <i style="font-size: 24px;" class="tim-icons icon-paper"></i>
          </base-button>
        </div>
        <form @submit.prevent="updateProfile">
          <div class="row">
            <div class="col-md-6">
              <legend>Edit Information</legend>

              <hr />
              <fieldset>
                <div class="edit_information_grid">
                  <div>
                    <base-input type="text" label="First Name" :disabled="true" placeholder="First Name"
                      v-model="user.firstName" addon-left-icon="tim-icons icon-single-02">
                    </base-input>
                  </div>
                  <div>
                    <base-input label="Middle Name" :disabled="true" v-model="user.middleName"
                      placeholder="Middle Name" addon-left-icon="tim-icons icon-single-02"></base-input>
                  </div>
                  <div>
                    <base-input type="text" label="Last Name" :disabled="true" placeholder="Last Name"
                      v-model="user.lastName" addon-left-icon="tim-icons icon-single-02">
                    </base-input>
                  </div>
                  <div>
                    <base-input label="Title" :error="getError('title')" :disabled="!canEditPNFields" v-model="user.title"
                      name="title" type="text" placeholder="Title" addon-left-icon="tim-icons icon-badge"></base-input>
                  </div>
                  <div>
                    <base-input label="Phone Number" :error="getError('phoneNumber')" :disabled="!canEditPNFields"
                      v-model="user.phoneNumber" name="phonenumber" type="text" placeholder="Phone number"
                      addon-left-icon="tim-icons icon-mobile"></base-input>
                  </div>
                  <div>
                    <base-input label="Email" disabled v-model="user.email" name="email" placeholder="Email"
                      addon-left-icon="tim-icons icon-email-85"></base-input>
                  </div>

                  <div>
                    <base-input disabled v-model="user.approvalStatusName" label="Status">
                    </base-input>
                  </div>
                  <div>
                    <base-input disabled v-model="this.user.approverNameLabel" label="Approver">
                    </base-input>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="row">
                  <div class="col-md-12">
                    <base-input :label="isPartner ? 'Partner Nation Manager' : 'Sponsor'" :error="getError('sponsor')">
                      <v-select class="style-chooser" v-model="user.sponsorId"
                        :disabled="isOUSD || (isSelf && isSponsor)" :aria-label="`${selectedSponserUserLabel}`"
                        v-b-popover.hover.top="selectedSponserUserLabel" name="sponsor" :reduce="(user) => user.id"
                        label="nameLabel" :options="filteredSponsorOptions" :selectable="selectable" placeholder="Select one">
                        <template v-slot:option="option">
                          {{ option.nameLabel }}
                        </template>
                      </v-select>
                    </base-input>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="row">
                  <div class="col-md-12">
                    <base-input v-if="!isPartner" :disabled="isOUSD || isSelf" label="Organization"
                      :error="getError('organization')">
                      <treeselect :disabled="isOUSD || isSelf" aria-label="Select organization from the dropdown list"
                        v-model="user.organizationId" class="select-primary" name="organization"
                        :options="jointStaffOrganizations" />
                    </base-input>
                    <base-input v-if="isPartner" label="Country" disabled="true" v-model="userCountries">
                    </base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <base-input label="Role(s)" :error="getError('roles')">
                      <v-select class="style-chooser" v-model="user.roles" name="roles" multiple
                        :disabled="isOUSD || isPartner || (!canSponsorEditFields && (isSelf && isSponsor))"
                        :reduce="(role) => role.name" label="name" :options="roles" placeholder="Select one">
                        <template #option="option">
                          <div :class="{ 'isNotApproved': !option.isActive }">
                            {{ option.name }}
                          </div>
                        </template>
                      </v-select>
                    </base-input>
                  </div>
                </div>

                <div v-if="isSponsor || isPNManager" class="row">
                  <div class="col-md-12">
                    <base-input v-if="canShowApprovalButtons" label="Approval">
                      <el-tooltip placement="top">
                        <template #content>
                          {{ lockUnlockInfo }}
                        </template>
                        <lock-button v-on:reloadUnlockLockInfo="reloadUnlockLockInfo"
                          v-bind:organizationId="user.organizationId" :id="$route.params.id"></lock-button>
                      </el-tooltip>
                      <approval-modal v-bind:organizationId="user.organizationId" :id="$route.params.id"
                        :user="user"></approval-modal>
                    </base-input>
                  </div>
                </div>
              </fieldset>
              <base-button v-if="isApprovedUser && !isOUSD && (isSponsor || isPNManager) && !isSuperAdmin"
                native-type="submit" size="md" :class="'btn_extra_small btn-primary'">
                Update Information
              </base-button>
              <base-button v-if="isApprovedUser && isSuperAdmin" native-type="submit" size="md"
                :class="'btn_extra_small btn-primary'">
                Update Information
                </base-button>
                 <base-button
              @click="returnToTable()"
              class="btn btn-primary"
            >
              <i class="tim-icons icon-double-left center-btn-content"></i> Back
            </base-button>



              <div class="row">
                <div class="col-md-12 italics">
                  <label for="LastLoginDate">{{ lastLoggedInInfo }} </label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 italics">
                  <label for="CreateDate">{{ createdDate }} </label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 italics">
                  <label for="EmailConfirmation">{{ confirmedEmailInfo }}
                  </label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 italics">
                  <label for="LastUpdatedBy">{{ lastUpdatedByInfo }} </label>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <fieldset>
                <legend>Documentation</legend>
                <user-upload ref="userDocuments" v-if="(!isOUSD) || isDisabled && loggedInisOUSD()"
                  :email="user.email" :type="'admin'" @file-changed="refreshUser"></user-upload>
              </fieldset>
              <hr />


              <fieldset>

                <legend v-if="!isOUSD && loggedInisOUSD()">Other Settings</legend>
                <base-button v-if="(!isOUSD) || isDisabled && loggedInisOUSD()" type="dark"
                  class="btn-fill" @click="resendEmailConfirmation()" :disabled="buttonDisabled">
                  Resend Email Confirmation Link
                </base-button>

                <el-tooltip v-if="user.isCacRegistered" :visible="visible" class="display-inline" effect="light"
                  placement="top" content="CAC registered">
                  <!-- <div  onmouseover="visible= true" class="ml-2">
                    </div> -->
                  <base-button class="btn btn-default btn-md btn-secondary" :disabled="user.isCacRegistered"><span><i
                        class="tim-icons icon-badge"></i> CAC Registered</span></base-button>
                </el-tooltip>
              </fieldset>
              <hr v-if="isVisible" />

              <fieldset v-if="isVisible">
                <legend>Partner Nations Managed</legend>
                <el-card disabled class="box-card" shadow="always">
                  <div style="text-align: left" v-for="i in countryIds" :key="i.id" class="text item"
                    :class="i.isPartnerNationApproval ? 'isApproved' : 'isNotApproved'">
                    <div class="text">
                      <i class="tim-icons icon-world"></i> {{ i.name }}
                      <span v-if="!i.isPartnerNationApproval">
                        (Not Active)
                      </span>
                    </div>
                  </div>
                </el-card>
              </fieldset>

              <fieldset>
                <div class="content_padding_top_small date">
                 
                  <label for="signatureDate">Account Expiration</label>
                  <!-- !permissions[0].hasPermission -->
                  <el-tooltip effect="dark" placement="top-start"
                    :disabled="canEditAccountExpiration"
                    :content="isPartner ? 'Contact Partner Nation Manager to update expiration date' : 'Contact Sponsor to update expiration date'">
                    <el-date-picker :disabled="!canEditAccountExpiration" id="signatureDate" type="date"
                      v-model="user.expirationDate" format="dd-MMMM-yyyy" data-vv-as="Account Expiration"
                      name="dateSigned" :editable="false" :picker-options="endDatePickerOptions" :clearable="false">
                    </el-date-picker>
                  </el-tooltip>
                </div>
                <span>Please select date in range of 1 year</span>
              </fieldset>
            </div>
          </div>
        </form>
      </div>
    </div>
  </center>
</template>

<script>
import UserUpload from "@/components/App/account/documents/UserDocuments";
import LockButton from "@/components/App/account/LockButton";
import ApprovalModal from "@/components/App/account/Approval";
import { mapGetters, mapActions } from "vuex";
import { Tabs, TabPane } from "@/components";
import Treeselect from "@riophae/vue-treeselect";
import Header from "@/components/App/Header.vue";
import swal from "sweetalert2";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Util from "@/util/util";
import axios from "@/axios";
import {
  Table,
  TableColumn,
  Upload,
  Button,
  Tag,
  Select,
  Option,
  Alert,
  Form,
  FormItem,
  CheckboxGroup,
  Checkbox,
  Divider,
  Tooltip,
  Card,
} from "element-ui";
import moment from "moment";
import { organizationNormalizer } from "@/util/formUtils"

export default {
  name: "AdminUserProfile",
  components: {
    ApprovalModal,
    LockButton,
    UserUpload,
    Tabs,
    TabPane,
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Alert.name]: Alert,
    [Tag.name]: Tag,
    [Form.name]: Form,
    [Tooltip.name]: Tooltip,
    [FormItem.name]: FormItem,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Divider.name]: Divider,
    [Select.name]: Select,
    [Option.name]: Option,
    Treeselect,
    Header,
  },
  data() {
    return {
      id: this.$route.params.id,
      existingApprovedById: null,
      buttonDisabled: false,
      visible: false,
      originalSponosrId: null,
      userLockSponsor: null,
      userUnlockSponosr: null,
      lockUnlockInfo: "This user hasn't been locked yet.",
      endDatePickerOptions: {
        disabledDate: this.disabledEndDate,
      },
      countryIds: [],
      isDisabled: false,
      isVisible: false,
      isTier1: false,
      activeTab: 'Profile'
    };
  },
  watch: {
    user: {
      deep: true,
      handler(newUserData, oldUserData) {
        if (newUserData.approvalStatusId !== 1) {
          this.existingApprovedById = oldUserData.approverId;
        }
        // Check lock status info when user data loads
        this.checkLockStatusInfo();
      },
    },
    // n = new lock sponsor user object, p = previous value
    getUserLockSponsor(n, p) {
      if (n != null && n != undefined && n != '') {
        // Has email = normal lock with LockedById
        if (n.email !== null && n.email !== undefined) {
          // If locked sponsor email is not null and id is not == the user id
          // if id == user id, it is because user unlock it by password reset only if they are
          
          if (n.id !== this.$route.params.id)
            this.lockUnlockInfo = `Account Locked by ${n.firstName} ${n.lastName} ${n.email} ${Util.formatDateWithLocalTimezone(n.lockedOutDate)}`;
          // Same user ID = self-lock from failed login attempts
          // locked out by EF not by someone else
          else
            this.lockUnlockInfo = `Locked: Failed login attempts ${Util.formatDateWithLocalTimezone(n.lockedOutDate)}`;
        } else {
          // Email is null = manual/system lock
          if (this.user && this.user.approvalStatusId == 4) {
            let lockDate = '';
            try {
              lockDate = this.user.lockedOutDate ? Util.formatDateWithLocalTimezone(this.user.lockedOutDate) : '';
            } catch (err) {
              lockDate = this.user.lockedOutDate;
            }
            this.lockUnlockInfo = `Account locked (manual/system) ${lockDate}`;
          }
        }
      } else {
        // No lock sponsor but user is locked = manual SQL lock (LockedById is NULL)
        if (this.user && this.user.approvalStatusId == 4) { 
          const lockDate = this.user.lockedOutDate ? Util.formatDateWithLocalTimezone(this.user.lockedOutDate) : '';
          this.lockUnlockInfo = `Account locked (manual/system) ${lockDate}`;
        }
      }
    },
    // n = new unlock sponsor user object, p = previous value
    getUserUnLockSponsor(n, p) {
      if (n != null && n != undefined && n != '') {
        if (n.email !== null && n.email !== undefined) {
          if (n.id !== this.$route.params.id)
            this.lockUnlockInfo = `Account unlocked by ${n.firstName} ${n.lastName} ${n.email} ${Util.formatDateWithLocalTimezone(n.unlockedOutDate)}`;
          else
            this.lockUnlockInfo = `Account unlocked user password reset.`;
        } else {
          // Email is null = manual/system unlock
          if (this.user && this.user.approvalStatusId == 2 && this.user.unlockedOutDate) {
            const unlockDate = Util.formatDateWithLocalTimezone(this.user.unlockedOutDate);
            this.lockUnlockInfo = `Account unlocked (manual/system) ${unlockDate}`;
          }
        }
      } else {
        // No unlock sponsor but has unlock date = manual SQL unlock (UnlockedById is NULL)
        if (this.user && this.user.approvalStatusId == 2 && this.user.unlockedOutDate) {
          const unlockDate = Util.formatDateWithLocalTimezone(this.user.unlockedOutDate);
          this.lockUnlockInfo = `Account unlocked (manual/system) ${unlockDate}`;
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      jointStaffOrganizations: "organization/jointStaffOrganizations",
      roles: "role/roles",
      approvalStatuses: "approvalStatus/approvalStatuses",
      permissionsFromStore: "permissions/permissions",
      sponsorUsers: "users/sponsorUsers",
      user: "users/user",
      getMyself: "authentication/getUser",
      isSponsor: "authentication/isSponsor",
      authenticatedUser: "users/authenticatedUser",
      isOUSD: "authentication/isOUSD",
      isPartnerAccount: "authentication/isPartnerAccount",
      isSuperAdmin: "authentication/isSuperAdmin",
      getUserLockSponsor: "users/getUserLockSponsor",
      getUserUnLockSponsor: "users/getUserUnLockSponsor",
      isPNManager: "authentication/isPNManager",
      allCountries: "countries/allCountries",
      authenticatedUserId: "authentication/authUserId",
    }),
    // Safe permissions getter that returns empty array if undefined
    permissions() {
      return this.permissionsFromStore || [];
    },
    // Check if user has permission to update application users
    hasPermission() {
      try {
        // If permissions array is empty or undefined, return true (permissive by default)
        if (!this.permissions || this.permissions.length === 0) {
          return true;
        }
        
        const key = `applicationusers:update`;
        
        // Check if any permission matches the key (case-insensitive)
        const hasAccess = this.permissions.some(p => {
          // Safely check if permission object has key property
          if (!p || typeof p.key !== 'string') {
            return false;
          }
          return p.key.toLowerCase() === key.toLowerCase();
        });
        
        return hasAccess;
      } catch (error) {
        // Return true on error to avoid blocking users
        return true;
      }
    },
    isPartner() {
      return this.user && this.user.roleString == Util.PARTNER_NATION;
    },
  
    isSelf() {
      if (this.user != null) {
        return this.user.id === this.getMyself.id;
      }
      return false;
    },
    userCountries() {
      var str = '';
      if (this.user.countriesToManage) {
        if (this.user.countriesToManage.length > 0)
          str = this.user.countriesToManage[0].name;
        return str;
      }
    },
    returnToTable(){
      this.$router.push("/admin/users")
    },  
    approver() {
      var approver = this.sponsorUsers.filter(d => d.id == this.user.sponsorId);
      if (approver.length > 0)
        return approver[0].approverNameLabel;
      else
        return '';
    },
    isLocked() {
      return this.user.approvalStatusName == "LOCKED" ? true : false;
    },
    isApproved() {
      return this.user.approvalStatusName == "APPROVED" ? true : false;
    },
    isApprovedUser() {
      return this.user.approvalStatusId == Util.APPROVED ? true : false;
    },
    async isPartnerRoleAssigned() {
      let userRoles = await this.user.roles
      if (userRoles) {
        return userRoles.includes(Util.PARTNER_NATION);
      }
    },
    canSponsorEditFields() {
      // Sponsors can edit user account roles and expiration dates
      // Backend will validate organizational hierarchy (user must be in sponsor's org or descendant orgs)
      return this.isSponsor;
    },
    canPNManagerEditFields() {
      try {
        // PN Managers are sponsors who manage specific Partner Nation countries
        // Must not be editing themselves
        // Must be a PN Manager
        // Must be editing a Partner Nation user from a country that this PN Manager manages
        if (!this.isPNManager || this.isSelf) {
          return false;
        }
        
        // Check if the user being edited is a Partner Nation user
        if (!this.user || !this.user.roles || !this.user.roles.includes("PartnerNation")) {
          return false;
        }
        
        // Check if both PN Manager and PN User are from the same country
        if (this.user.countriesToManage && this.user.countriesToManage.length > 0 && 
            this.getMyself && this.getMyself.countries) {
          const pnUserCountryId = this.user.countriesToManage[0].countryId;
          const pnManagerCountryIds = this.getMyself.countries;
          return pnManagerCountryIds.includes(pnUserCountryId);
        }
        
        return false;
      } catch (error) {
        return false;
      }
    },
    canEditPNFields() {
      // Only Partner Nation Managers can edit Title, Phone Number & Account Expiration
      // for Partner Nation users
      return this.canPNManagerEditFields;
    },
    canEditAccountExpiration() {
      // Account Expiration can be edited by:
      // 1. Sponsors for their organizational users (backend validates org hierarchy)
      // 2. Partner Nation Managers for Partner Nation users in their managed countries
      
      // If logged-in user is a Sponsor and not editing themselves
      if (this.isSponsor && !this.isSelf) {
        return true;
      }
      
      // If logged-in user is a PN Manager editing a PN user from their managed country
      if (this.canPNManagerEditFields) {
        return true;
      }
      
      return false;
    },
    canShowApprovalButtons() {
      // Show approval buttons if:
      // 1. Sponsors can lock/unlock users in their organizational hierarchy
      // 2. Partner Nation Manager viewing Partner Nation user from same country they are managing
      // 3. Original condition: isDisabled && loggedInisOUSD()
      
      // Sponsors can lock/unlock users (except themselves)
      if (this.isSponsor && !this.isSelf) {
        return true;
      }
      
      // Allow PN Managers to see approval buttons for PN users from their country
      if (this.isPNManager && this.user.roles && this.user.roles.includes("PartnerNation")) {
        if (this.user.countriesToManage && this.user.countriesToManage.length > 0 && this.getMyself.countries) {
          const pnUserCountryId = this.user.countriesToManage[0].countryId;
          const pnManagerCountryIds = this.getMyself.countries;
          return pnManagerCountryIds.includes(pnUserCountryId);
        }
      }
      
      // Original condition for backwards compatibility
      if (this.isDisabled && this.loggedInisOUSD()) {
        return true;
      }
      
      return false;
    },
    lastLoggedInInfo() {
      return Util.isNullOrEmpty(this.user.lastLoginDate)
        ? `We do not have record of the last time ${this.user.firstName} logged in.`
        : `${this.user.firstName
        } last logged in on: ${Util.formatDateWithLocalTimezone(
          this.user.lastLoginDate
        )}`;
    },
    confirmedEmailInfo() {
      return this.user.emailConfirmed
        ? `${this.user.firstName}'s email IS confirmed.`
        : `${this.user.firstName}'s email is NOT confirmed.`;
    },
    lastUpdatedByInfo() {
      if (this.user.updatedBy) {
        const str = this.user.updatedBy;
        // Extract the name part
        const namePart = str.substring(0, str.indexOf('--'));
        // Extract the email part
        const emailPart = str.substring(str.indexOf('--') + 3, str.lastIndexOf('--') - 1);
        // Extract the date and time part
        const dateTimePart = str.substring(str.lastIndexOf('--') + 3);
        const formattedDate = Util.formatDateWithLocalTimezone(dateTimePart)
        return Util.isNullOrEmpty(this.user.updatedById) ?
          `We do not have record of last updated by for the user` :
          `Profile last updated by ${namePart}--${emailPart}--${formattedDate}`
      }
    },
    createdDate() {
      return Util.isNullOrEmpty(this.user.createDate) ?
        `We do not have record of Create date for the user` :
        `${this.user.firstName} registered on: ${Util.formatDateWithLocalTimezone(this.user.createDate)}`
    },
    selectedSponserUserLabel() {
      let selectedUser;
      if (this.user.sponsorId) {
        selectedUser = this.sponsorUsers.find(
          (user) => user.id === this.user.sponsorId
        );
      }
      return selectedUser ? selectedUser.nameLabel : "No user selected";
    },
    filteredSponsorOptions() {
      // Safety check: ensure sponsorUsers array exists
      if (!this.sponsorUsers || !Array.isArray(this.sponsorUsers)) {
        return [];
      }

      // For Partner Nation users, show only approved and not locked Partner Nation Managers for their country
      if (this.isPartner && this.user && this.user.countriesToManage && Array.isArray(this.user.countriesToManage) && this.user.countriesToManage.length > 0) {
        const userCountryId = this.user.countriesToManage[0].countryId;
        
        // Filter to valid PN Managers for this country
        const filtered = this.sponsorUsers.filter(sponsor => {
          // Safety check for sponsor object
          if (!sponsor) {
            return false;
          }

          // Check for PartnerNationManager role
          const hasPartnerNationManagerRole = 
            sponsor.roles && Array.isArray(sponsor.roles) && sponsor.roles.includes('PartnerNationManager');
          
          if (!hasPartnerNationManagerRole) {
            return false;
          }
          
          // Must be approved (approvalStatusId = 2) and not locked
          if (sponsor.approvalStatusId !== 2 || sponsor.locked) {
            return false;
          }
          
          // Must be assigned to the same country as the Partner Nation user
          if (!sponsor.countriesToManage || !Array.isArray(sponsor.countriesToManage) || sponsor.countriesToManage.length === 0) {
            return false;
          }
          
          const sponsorCountryIds = sponsor.countriesToManage.map(c => c.countryId);
          const hasMatchingCountry = sponsorCountryIds.includes(userCountryId);
          
          if (!hasMatchingCountry) {
            return false;
          }
          
          return true;
        });

        // Always include the current Partner Nation Manager in the options so we display their name, not the GUID
        // This handles cases where the PN Manager's country permissions changed but they're still assigned as sponsor
        if (this.user.sponsorId) {
          const currentSponsorInList = filtered.some(s => s.id === this.user.sponsorId);
          if (!currentSponsorInList) {
            // First try to find in the full sponsorUsers list
            const currentSponsor = this.sponsorUsers.find(s => s.id === this.user.sponsorId);
            if (currentSponsor) {
              filtered.unshift(currentSponsor);
            } else if (this.user.sponsorNameLabel) {
              // Fallback: Create a placeholder option using the user's sponsor info
              // This handles cases where the sponsor is locked/rejected and not in sponsorUsers
              filtered.unshift({
                id: this.user.sponsorId,
                nameLabel: this.user.sponsorNameLabel,
                isDisabled: true // Prevent re-selection of invalid sponsor
              });
            }
          }
        }

        return filtered;
      }
      
      // For non-Partner Nation users, return all sponsors (including Partner Nation Managers)
      return this.sponsorUsers;
    },
  },
  async mounted() {
    this.$loaderApp.addRequest();
    await this.getRoles(this.$route.params.id);
    await this.getApprovalStatuses();
    await this.getSponsorUsers(true);
    await this.getUserByEmail();
    await this.getUser(this.$route.params.id);
    this.originalSponosrId = this.user['sponsorId'];
    await this.validateOrganization(this.user.organizationId);
    
    // Only load the relevant sponsor info based on current status
    // ApprovalStatusId 4 = LOCKED, 2 = APPROVED/UNLOCKED
    if (this.user.approvalStatusId == 4) {
      await this.loadUserLockSponsor(this.$route.params.id);
    } else if (this.user.approvalStatusId == 2 && this.user.unlockedOutDate) {
      await this.loadUserUnLockSponsor(this.$route.params.id);
    }
    
    // Check lock status after loading lock/unlock sponsor data
    this.checkLockStatusInfo();
    
    await this.getAllCountries()
    await this.getSelectedCountries();
    //await this.partnerNationCondition(await this.getMyself.id);
    await this.partnerNationCondition();
    await this.checkRoles('PartnerNationManager')
    await this.checkTier1()
    this.activeTab = 'Profile'

    //this permission is only for the button to do the entire page we need to add attributes
    // which isnt happening on this iteration
    // disabling for now
    try {
      const val = await this.checkPermission({resource:'applicationUsers', action:'update',  data: { Id: this.$route.params.id }});
    } catch (error) {
      // Permission check skipped
    }
    await this.agreementInformationCountryChanged();
    await this.getJointStaffOrganizations();
    this.$loaderApp.completeRequest();
  },
  methods: {
    ...mapActions({
      getJointStaffOrganizations: "organization/getJointStaffOrganizations",
      getRoles: "role/getUserRoles",
      // disabling for now
      checkPermission: "permissions/checkPermission",
      getApprovalStatuses: "approvalStatus/getApprovalStatuses",
      getSponsorUsers: "users/getSponsorUsers",
      updateUser: "users/updateUserAdmin",
      getUser: "users/getUser",
      getUserByEmail: "authentication/getUserByEmail",
      loadUserUnLockSponsor: "users/loadUserUnLockSponsor",
      loadUserLockSponsor: "users/loadUserLockSponsor",
      getAllCountries: "countries/getAllCountries",
      agreementInformationCountryChanged:
        "agreementInformation/agreementInformationCountryChanged",
    }),
    organizationNormalizer(node) {
      return organizationNormalizer(node, "organizationId", "name", "children");
    },
    updateActiveTab(tab) {
      this.activeTab = tab;
    },
    async reloadUnlockLockInfo() {
      const userId = this.$route.params.id;
      // Refresh user data first and wait for Vue to update
      await this.getUser(userId);
      // Use nextTick to ensure Vuex state is updated before checking
      await this.$nextTick();
      
      // Only load the relevant sponsor info based on current status
      // ApprovalStatusId 4 = LOCKED, 2 = APPROVED/UNLOCKED
      const currentStatus = this.user.approvalStatusId;
      if (currentStatus == 4) {
        // User is now locked - load lock sponsor info
        await this.loadUserLockSponsor(userId);
      } else if (currentStatus == 2) {
        // User is now unlocked - load unlock sponsor info
        await this.loadUserUnLockSponsor(userId);
      }
      this.checkLockStatusInfo();
    },
    checkLockStatusInfo() {
      if (!this.user) return;
      
      // Check if user is locked (ApprovalStatusId = 4)
      if (this.user.approvalStatusId == 4) { // Use == instead of === for type coercion
        // Check if we have lock sponsor info (normal lock with LockedById)
        if (this.getUserLockSponsor && this.getUserLockSponsor.email) {
          // Will be handled by getUserLockSponsor watcher
          return;
        }
        // Manual/system lock (NULL LockedById)
        const lockDate = this.user.lockedOutDate ? 
          Util.formatDateWithLocalTimezone(this.user.lockedOutDate) : '';
        this.lockUnlockInfo = `Account locked (manual/system) ${lockDate}`;
      }
      // Check if user was previously locked and is now unlocked (ApprovalStatusId = 2 and has unlockedOutDate)
      else if (this.user.approvalStatusId == 2 && this.user.unlockedOutDate) { // Use == instead of === for type coercion
        // Check if we have unlock sponsor info (normal unlock with UnlockedById)
        if (this.getUserUnLockSponsor && this.getUserUnLockSponsor.email) {
          // Will be handled by getUserUnLockSponsor watcher
          return;
        }
        // Manual/system unlock (NULL UnlockedById)
        const unlockDate = Util.formatDateWithLocalTimezone(this.user.unlockedOutDate);
        this.lockUnlockInfo = `Account unlocked (manual/system) ${unlockDate}`;
      }
      else {
        // User has never been locked
        this.lockUnlockInfo = "This user hasn't been locked yet";
      }
    },
    loggedInisOUSD() {
      if (this.user.roles) {
        if (!this.getMyself.roles.includes('Ousd')) {
          return true;
        }
      }

      return false
    },
    async checkTier1() {
      this.isTier1 = await this.user.roles.includes('Tier1');
      return true;
    },
    async checkRoles(role) {

      let userRoles = await this.user.roles
      if (userRoles) {
        if (userRoles.includes(role)) {
          this.isVisible = true
          return false
        } else {
          this.isVisible = false
          return true
        }
      }
    },
    /*async getLoggedInCountries(id) {
        const loggedInUser = await axios.get("/api/applicationusers/id/" + id, { config: { showToast: false } });
        const loggedInUserCountries = loggedInUser.data.countriesToManage;
        return loggedInUserCountries
      },*/
    async getLoggedInCountries(id) {
      // guard against null or undefined calls
      if (!id) {
        return []
      }
      const { data } = await axios.get(
        `/api/applicationusers/id/${id}`,
        { config: { showToast: false } }
      )
      return data.countriesToManage || []
    },
    async partnerNationCondition(id) {
      // Use teh getter directly here, it's synchronous
      const loggedInUserId = this.getMyself.id
      //let loggedInUserCountries = await this.getLoggedInCountries(id);
      let loggedInUserCountries = await this.getLoggedInCountries(loggedInUserId);
      let userCountries = await this.user.countriesToManage
      let roles = await this.user.roles
      if (roles && roles.includes('PartnerNation') && this.isPNManager) {
        if (loggedInUserCountries && userCountries) {
          let profileCountryIds = userCountries.map((e) => e.countryId
          )
          let loggedInCountryIds = loggedInUserCountries.map((e) =>
            e.countryId
          )
          const intersection = profileCountryIds.filter(element => loggedInCountryIds.includes(element));
          if (intersection.length > 0) {
            this.isDisabled = false
            return false
          } else {
            this.isDisabled = true
            return true
          }
        } else {
          this.isDisabled = false
          return false
        }
      } else if (this.isSponsor) {
        if (this.user.sponsorId === this.getMyself.id) {
          this.isDisabled = false
          return false
        }
        else {
          this.isDisabled = true
          return true
        }

      } else {
        this.isDisabled = false
        return false
      }
    },

    disabledEndDate(time) {
      let disabled = false;
      let userRoles = this.user.roles;

      const selectedTime = new moment(time.getTime());
      let maxEndDate = null;
      // today's date
      const minstartDate = new moment(moment());
      if (userRoles) {
        maxEndDate = new moment(minstartDate).add(
          1,
          "year"
        );
      }

      // not less then today
      if (selectedTime < minstartDate) {
        disabled = true;
      }
      // not greater than a year from today
      if (selectedTime > maxEndDate) {
        disabled = true;

      }
      return disabled;
    },

    selectable(option) {
      // if this use is an admin, all options are selectable
      // except admin-self and the current editing user-self
      if (this.isSuperAdmin) {
        return option.id !== this.getMyself.id && option.id !== this.user.id;
      }
      // can only select/assign yourself to the user that you want to modify
      return option.id === this.getMyself.id;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validateOrganization(organizationId) {
      let ctx = this;
      let found = ctx.jointStaffOrganizations.find(
        (o) => o.organizationId === organizationId || 48
      );

      return (found && found.organizationId) || 48;
    },
    async updateProfile(id) {
      const ctx = this;
      const isTier1 = this.isTier1;
      try {
        ctx
          .updateUser({ isSuperAdmin: false, isTier1 },)
          .then(async (res) => {
            if (res.status != false) {
              await ctx.getUser(this.id);
              new swal({
                title: "Successfully Saved",
                text: `User information updated successfully!`,
                icon: "success",
                confirmButtonColor: "#10b45a",
              });
            } else {
              await ctx.getUser(this.id);

              new swal({
                title: "Error!",
                text: `${res.res}`,
                icon: "error",
                confirmButtonColor: "#10b45a",
              });
            }
          })
      } catch (error) {
        new swal({
          title: "Error!",
          text: `${error}`,
          icon: "error",
          confirmButtonColor: "#10b45a",
        });
      }
    },
    async refreshUser() {
      await this.getUser(this.id);
    },
    resendEmailConfirmation() {
      this.buttonDisabled = true;
      const id = this.$route.params.id;
      const params = {
        id,
      };
      axios
        .get("api/authentication/resendconfirmemail", {
          params,
        })
        .then((response) => {
          new swal({
            title: "Success!",
            text: "Email Resent successfully",
            icon: "success",
            confirmButtonColor: "#10b45a",
          });
          this.buttonDisabled = false;
        })
        .catch((err) => {
          new swal({
            title: "Error!",
            text: "Email Resend Failed!",
            icon: "error",
            confirmButtonColor: "#10b45a",
          });
          this.buttonDisabled = false;
        });
    },
    getSelectedCountries() {
      if (this.user.countriesToManage) {
        var countries = this.user.countriesToManage;
        let temp = countries.map(a => {
          var ret = {
            id: a.countryId,
            name: a.name,
            isPartnerNationApproval: (a.isPartnerNationApproval) ? true : false
          };
          return ret;
        });

        var result = [];
        var approved = temp.filter(c => c.isPartnerNationApproval == true);
        var notApproved = temp.filter(c => !c.isPartnerNationApproval);
        result.push(...approved, ...notApproved);
        this.countryIds = result;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.edit_information_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
}

.date {
  width: 50%;
}

@media only screen and (max-width: 1200px) {
  .edit_information_grid {
    grid-template-columns: 1fr;
  }
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.text {
  font-size: 12px !important;
  padding-top: 3px;
}

// .item {
//   margin-bottom: 18px;
// }

.isApproved {
  color: #048000;

  .tim-icons {
    color: green;
  }
}

.isNotApproved {
  color: grey;
}


.box-card {
  width: 280px;
  height: 150px;
  overflow: auto;
}

.card-style {
  text-align: left;
  margin-left: auto;
  margin-right: auto;
}

.tab-content.tab-subcategories {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.more-width {
  width: 28%;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.order-status {
  margin-top: 5px;
  margin-bottom: 5px;
}

/* Change Duplicate Transaction and other btn-warning buttons to be darker orange for 508 compliance */
.btn-warning {
  background-image: none !important;
  background-color: #d5440f;
}

@media (max-width: 1300px) {
  .col-md-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 50%;
    flex: 0 0 100%;
    max-width: 80%;
  }
}

.auto {
  margin: auto;
}

.hide {
  border-right: 1px solid #d3d3d3;

  @media only screen and (max-width: 1026px) {
    border-right: none;
  }
}
</style>
